"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_THUMBNAIL_URL = exports.NEW_URL_THUMBNAIL_URL = exports.NEW_PREVIEW_URL = exports.OLD_URL_PREVIEW_NAME = exports.OLD_PREVIEW_NAME = void 0;
exports.OLD_PREVIEW_NAME = 'file.png';
exports.OLD_URL_PREVIEW_NAME = 'turl.png-C';
exports.NEW_PREVIEW_URL = '/X5/src/apps/new-doccenter/common/theme/images/new-content-preview.png';
exports.NEW_URL_THUMBNAIL_URL = '/X5/src/apps/new-doccenter/common/theme/images/grid-thumbnail-url.jpg';
exports.NEW_THUMBNAIL_URL = '/X5/src/apps/new-doccenter/common/theme/images/new-content-thumbnail.png';
//# sourceMappingURL=PreviewUrls.js.map